export default __webpack_public_path__ + "static/media/business.d9d85c23.PNG";